import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SessionService } from '../Services/session.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-session-timeout-modal',
    templateUrl: './session-timeout-modal.component.html',
    styleUrls: ['./session-timeout-modal.component.scss'],
    standalone: false
})
export class SessionTimeoutModalComponent {

  @Input() continueButtonDisabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(readonly sessionService: SessionService,
              public announcer: LiveAnnouncer,
              private dialogRef: MatDialogRef<SessionTimeoutModalComponent>) { }

  endSession(): void {
    this.dialogRef.close();
    this.sessionService.endSession();
  }

  refreshSession(): void {
    this.announcer.announce("","off")

    this.continueButtonDisabled.next(true);
    let resetFocusItem = document.getElementById('faq-button');
    resetFocusItem?.focus();
    this.announcer.announce("Session extended","assertive")
    this.continueButtonDisabled.next(false);
    this.sessionService.resetIdleTimer();
    this.dialogRef.close();
  }
}
